export default function() {
  const widgetName = 'eventFeedAuto';
  const widgetOpts = eventFeedAutoOpts;
  
  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
      , detectIpad: false
      // options
      , allEventsLink: false
      , allEventsLinkText: 'SEE ALL EVENTS'
      , hasImages: true
      , imageBackground: false
      , lazyLoadImages: true
      , buyNowButton: {visible: false, text: 'BUY NOW'}
      , moreButton: {visible: false, text: 'More >'}
      , maxItemsVisible: 4
      , isResponsive: false
      , hasDescription: false
      , textContainer: true
      , link: 'all' //options are 'all', 'text', 'image', 'imageAndText', or ''
      , attributeOrder: {
        1: 'date',
        2: 'image',
        3: 'title',
        4: 'description',
        5: 'buttons'
      }
      , multiFeatureLoaded: function(data){
        // console.log(data);

        function buildCardHTML(title, date, image, url, purchaseable) {
          const noURLClass = url === 'javascript:void(0);' ? 'void-link' : '';
          let moretext = '<span class="card-widget-more">More &gt;</span>';
          if (!purchaseable) {
            moretext = '';
          }

          let mfItemHTML = `
            <a href="${url}" class="card-widget-item ${noURLClass}">
              <span class="card-widget-date">${date}</span>
              <div class="outer-image-container">
                <div class="image-container lozad" data-background-image="${image}"></div>
              </div>
              <div class="card-content">
                <span class="card-widget-title">${title}</span>
                ${moretext}
              </div>
            </a>
          `;

          return mfItemHTML;

        }

        const newItems = data.slice(0,4).map(function(item, i) {
          let title = item.Name;
          let url = item.URL || 'javascript:void(0);';

          let date = function(d) {
            let month = d.slice(0, 3);
            let day = d.slice(4, 7).replace(',', '');
            return `${month}<span class="day">${day}</span>`;
          }
          
          return buildCardHTML(title, date(item.Date), item.ImageURL, url, item.Purchaseable);
        });


        $(`#${widgetName}`).html(newItems.join(''));
        $("<div class='widget-title'><span>On The Calendar</span><span>Here's what's up next...</span></div>").prependTo(`#${widgetName}`);
        
      }
  });

};

